import React from "react";
import "./style.scss";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Recommendations from "../../components/Recommendations";
import OrderIdle from "../../components/OrderIdle";

const RecommendationPage = () => {
 
    return <div className="RecommendationPage">
        <Header />
        <Recommendations />
        <Footer />
        <OrderIdle />
    </div>
}

export default RecommendationPage;